module.exports = __webpack_public_path__ + "static/media/uadvisory-header-bg.a1350c43.svg";